import { render, staticRenderFns } from "./DasherTeamStatus.vue?vue&type=template&id=53487c7c&scoped=true"
import script from "./DasherTeamStatus.vue?vue&type=script&lang=js"
export * from "./DasherTeamStatus.vue?vue&type=script&lang=js"
import style0 from "./DasherTeamStatus.vue?vue&type=style&index=0&id=53487c7c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53487c7c",
  null
  
)

export default component.exports